import { FormEvent, useState } from 'react';
import { getAuthErrorMessage, resetEmailPassword } from './auth.api';
import './ResetPasswordPage.css';

type ResetPasswordPageProps = {
  token: string;
  onBackToLanding: () => void;
  onOpenLogin: () => void;
};

export function ResetPasswordPage({ token, onBackToLanding, onOpenLogin }: ResetPasswordPageProps) {
  const [newPassword, setNewPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const [error, setError] = useState('');
  const [status, setStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError('');
    setStatus('');

    if (!token) {
      setError('Ссылка для восстановления некорректна или устарела.');
      return;
    }

    if (newPassword.length < 8) {
      setError('Новый пароль должен быть не короче 8 символов');
      return;
    }

    if (newPassword !== repeatPassword) {
      setError('Пароли не совпадают');
      return;
    }

    setIsSubmitting(true);

    try {
      await resetEmailPassword(token, newPassword);
      setNewPassword('');
      setRepeatPassword('');
      setStatus('Пароль изменен. Теперь можно войти с новым паролем.');
    } catch (requestError) {
      setError(getAuthErrorMessage(requestError));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="reset-password-page">
      <div className="background-glow" />
      <section className="reset-password-card">
        <button className="reset-password-brand" type="button" onClick={onBackToLanding}>MifVPN</button>
        <div className="reset-password-head">
          <span className="eyebrow compact">Восстановление доступа</span>
          <h1>Новый пароль</h1>
          <p>Введите новый пароль для аккаунта. После успешного сброса можно вернуться ко входу.</p>
        </div>

        <form className="reset-password-form" onSubmit={handleSubmit} noValidate>
          <label>
            <span>Новый пароль</span>
            <input
              autoComplete="new-password"
              minLength={8}
              placeholder="Минимум 8 символов"
              required
              type="password"
              value={newPassword}
              onChange={(event) => setNewPassword(event.target.value)}
            />
          </label>
          <label>
            <span>Повторите пароль</span>
            <input
              autoComplete="new-password"
              minLength={8}
              placeholder="Повторите новый пароль"
              required
              type="password"
              value={repeatPassword}
              onChange={(event) => setRepeatPassword(event.target.value)}
            />
          </label>

          {error ? <div className="reset-password-message error">{error}</div> : null}
          {status ? <div className="reset-password-message success">{status}</div> : null}

          <button className="button button-primary reset-password-submit" type="submit" disabled={isSubmitting || Boolean(status)}>
            {isSubmitting ? 'Сохраняем...' : 'Сохранить пароль'}
          </button>
          {status ? (
            <button className="button button-secondary reset-password-submit" type="button" onClick={onOpenLogin}>
              Войти
            </button>
          ) : null}
        </form>
      </section>
    </main>
  );
}
